import { render, staticRenderFns } from "./AddFeeType.vue?vue&type=template&id=f191fbce&scoped=true"
import script from "./AddFeeType.vue?vue&type=script&lang=js"
export * from "./AddFeeType.vue?vue&type=script&lang=js"
import style0 from "./AddFeeType.vue?vue&type=style&index=0&id=f191fbce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f191fbce",
  null
  
)

export default component.exports